import { PageContent, PageTitle, PageTitle2 } from "../components/Page";
import { CampingRoute } from "../router/CampingRoute";
import LogoFQCC from "./Home/fqcc.png";

function Prices() {
  return (
    <PageContent>
      <PageTitle className="md:hidden">Tarifs</PageTitle>
      <div className="mt-4 grid gap-6 lg:grid-cols-[1fr_260px]">
        <div className="space-y-6">
          <section className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm sm:p-5">
            <PageTitle2>Tente au sol</PageTitle2>
            <p className="mt-1 text-sm text-slate-600">
              <em>Ces prix incluent 2 adultes et 2 enfants</em>
            </p>
            <dl className="mt-4 space-y-3">
              <dt className="text-slate-700">
                2 services (eau, électricité)
              </dt>
              <dd className="grid gap-3 sm:grid-cols-2">
                <span className="rounded-lg bg-slate-50 px-3 py-2 text-sm font-semibold text-slate-900">
                  À la journée : 30,00$ + taxes
                </span>
                <span className="rounded-lg bg-slate-50 px-3 py-2 text-sm font-semibold text-slate-900">
                  À la semaine : 180,00$ + taxes
                </span>
              </dd>
            </dl>
          </section>

          <section className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm sm:p-5">
            <PageTitle2>Roulotte ou Tente-roulotte</PageTitle2>
            <p className="mt-1 text-sm text-slate-600">
              <em>Ces prix incluent 2 adultes et 2 enfants</em>
            </p>
            <dl className="mt-4 space-y-3">
              <dt className="text-slate-700">
                3 services (eau, électricité 30 amp., égout)
              </dt>
              <dd className="grid gap-3 sm:grid-cols-2">
                <span className="rounded-lg bg-slate-50 px-3 py-2 text-sm font-semibold text-slate-900">
                  À la journée : 40,00$ + taxes
                </span>
                <span className="rounded-lg bg-slate-50 px-3 py-2 text-sm font-semibold text-slate-900">
                  À la semaine : 240,00$ + taxes
                </span>
              </dd>
            </dl>
          </section>

          <section className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm sm:p-5">
            <PageTitle2>Visiteurs</PageTitle2>
            <dl className="mt-4 space-y-4 text-slate-700">
              <dt>Adulte</dt>
              <dd className="grid gap-3 sm:grid-cols-2">
                <span className="rounded-md bg-slate-50 px-3 py-2 text-sm font-semibold text-slate-900">
                  Jour : 5,00$ *
                </span>
                <span className="rounded-md bg-slate-50 px-3 py-2 text-sm font-semibold text-slate-900">
                  Nuit : 3,00$ *
                </span>
              </dd>
              <dt>Enfant (moins de 18 ans)</dt>
              <dd className="grid gap-3 sm:grid-cols-2">
                <span className="rounded-md bg-slate-50 px-3 py-2 text-sm font-semibold text-slate-900">
                  Jour : 3,00$ *
                </span>
                <span className="rounded-md bg-slate-50 px-3 py-2 text-sm font-semibold text-slate-900">
                  Nuit : 3,00$ *
                </span>
              </dd>
            </dl>

            <div className="mt-4 rounded-lg bg-slate-50 p-3 text-sm text-slate-700">
              <p>
                <em>
                  Une carte de visiteur pour la saison est aussi disponible
                </em>
              </p>
              <dl className="mt-3 grid gap-y-2 gap-x-3 text-slate-900 sm:grid-cols-[max-content_auto] sm:items-center">
                <dt className="font-semibold">Par personne</dt>
                <dd className="justify-self-start rounded-md bg-white px-3 py-2 text-left font-semibold whitespace-nowrap">
                  25,00$ *
                </dd>
                <dt className="font-semibold">Par famille</dt>
                <dd className="justify-self-start rounded-md bg-white px-3 py-2 text-left font-semibold whitespace-nowrap">
                  60,00$ *
                </dd>
              </dl>
            </div>
          </section>

          <section className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm sm:p-5">
            <PageTitle2>Locations</PageTitle2>
            <p className="mt-1 text-sm text-slate-600">
              <em>Ceintures incluses</em>
            </p>
            <div className="mt-3 grid gap-y-2 gap-x-3 text-slate-700 sm:grid-cols-[max-content_auto] sm:items-center">
              <p className="text-sm font-semibold uppercase tracking-wide text-slate-500 sm:col-span-2">
                Pour 2 heures
              </p>
              <span>Kayak (2 de disponible)</span>
              <span className="justify-self-start rounded-md bg-slate-50 px-3 py-2 text-left text-sm font-semibold text-slate-900 whitespace-nowrap">
                15$ *
              </span>
              <span>Chaloupe (2 de disponible)</span>
              <span className="justify-self-start rounded-md bg-slate-50 px-3 py-2 text-left text-sm font-semibold text-slate-900 whitespace-nowrap">
                15$ *
              </span>
              <span>Pédalo 4 places (1 de disponible)</span>
              <span className="justify-self-start rounded-md bg-slate-50 px-3 py-2 text-left text-sm font-semibold text-slate-900 whitespace-nowrap">
                15$ *
              </span>
            </div>
          </section>
        </div>

        <aside>
          <a
            className="block rounded-xl border border-slate-200 bg-slate-50 p-4 text-center shadow-sm transition hover:shadow-md"
            href="http://www.fqcc.ca/"
          >
            <p className="text-xs uppercase tracking-wide text-slate-500">
              Avantage membre
            </p>
            <p className="mt-2 text-base font-semibold text-slate-900">
              10% de rabais pour les membres
            </p>
            <div className="mt-4 border-t border-slate-200 pt-4">
              <img
                className="mx-auto w-32"
                alt="Logo FQCC"
                src={LogoFQCC}
                title="FQCC"
              />
            </div>
          </a>
        </aside>
      </div>
    </PageContent>
  );
}

export const PricesRoute: CampingRoute = {
  title: "Tarifs",
  path: "/tarifs",
  element: <Prices />,
};
